import { render, staticRenderFns } from "./AppointmentConfirm.vue?vue&type=template&id=1bcc60f4&scoped=true"
import script from "./AppointmentConfirm.vue?vue&type=script&lang=js"
export * from "./AppointmentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc60f4",
  null
  
)

export default component.exports